import { API_TYPE } from "../../../utils/config";

export const POST_ACTIVITY_SEARCH = API_TYPE("POST_ACTIVITY_SEARCH");
export const RESET_POST_ACTIVITY_SEARCH = API_TYPE(
  "RESET_POST_ACTIVITY_SEARCH"
);
export const GET_ACTIVITIES_LIST = API_TYPE("GET_ACTIVITIES_LIST");
export const RESET_GET_ACTIVITIES_LIST = "RESET_GET_ACTIVITIES_LIST";
export const GET_ACTIVITY_EXTRA_DETAILS = API_TYPE(
  "GET_ACTIVITY_EXTRA_DETAILS"
);
export const RESET_GET_ACTIVITY_EXTRA_DETAILS =
  "RESET_GET_ACTIVITY_EXTRA_DETAILS";
export const GET_ACTIVITY_AGE_BAND = API_TYPE("GET_ACTIVITY_AGE_BAND");
export const RESET_GET_ACTIVITY_AGE_BAND = "RESET_GET_ACTIVITY_AGE_BAND";
export const GET_ACTIVITY_CATEGORIES = API_TYPE("GET_ACTIVITY_CATEGORIES");
export const RESET_GET_ACTIVITY_CATEGORIES = "RESET_GET_ACTIVITY_CATEGORIES";
export const GET_ACTIVITY_ALL_DETAILS = API_TYPE("GET_ACTIVITY_ALL_DETAILS");
export const RESET_GET_ACTIVITY_ALL_DETAILS = "RESET_GET_ACTIVITY_ALL_DETAILS";
export const GET_ACTIVITY_PRODUCT_INFO = API_TYPE("GET_ACTIVITY_PRODUCT_INFO");
export const RESET_GET_ACTIVITY_PRODUCT_INFO = "RESET_GET_ACTIVITY_PRODUCT_INFO";
export const ACTIVITY_PRE_BOOK = API_TYPE("ACTIVITY_PRE_BOOK");
export const RESET_ACTIVITY_PRE_BOOK = "RESET_ACTIVITY_PRE_BOOK";
export const ACTIVITY_CHECKOUT = API_TYPE("ACTIVITY_CHECKOUT");
export const RESET_ACTIVITY_CHECKOUT = "RESET_ACTIVITY_CHECKOUT";

// these are used to know whether to call particular apis or not
export const SET_CALL_ACTIVITIES_LIST_API = "SET_CALL_ACTIVITIES_LIST_API";
export const SET_CALL_ACTIVITY_EXTRA_DETAILS_API =
  "SET_CALL_ACTIVITY_EXTRA_DETAILS_API";
export const SET_CALL_ACTIVITY_ALL_DETAILS_API =
  "SET_CALL_ACTIVITY_ALL_DETAILS_API";
export const PASSPORT_DETAILS_BY_BOOKINGID = API_TYPE("PASSPORT_DETAILS_BY_BOOKINGID")
